import {Inject, Injectable} from "@angular/core";
import {ConnectionHttpService, ApiResourceLocation, SOFTLINE_SERVICE_HTTP} from "@softline/core";
import {SOFTLINE_API_LLR_KOMMISSIONIERUNG_EMBALLAGEN_SCHREIBEN,} from "../kommissionierung.api";
import {Observable} from "rxjs";
import {Kommissionierung, KommissionierungBewegung} from "../types/kommissionierung";

@Injectable()
export class EmballageService {
  private emballagenSchreibenLocation(idkopfbskomm: string): ApiResourceLocation {
    return {
      path: SOFTLINE_API_LLR_KOMMISSIONIERUNG_EMBALLAGEN_SCHREIBEN,
      pathParams: {
        idkopfbskomm: idkopfbskomm,
      }
    }
  }

  constructor(
    @Inject(SOFTLINE_SERVICE_HTTP) private httpService: ConnectionHttpService
  ) {}

  emballagenSchreiben(idkopfbskomm: string, emballagen: KommissionierungBewegung[]): Observable<Kommissionierung> {
    const location = this.emballagenSchreibenLocation(idkopfbskomm);
    const payload = emballagen ?? []

    return this.httpService.create<object, Kommissionierung>(location, payload);
  }
}
